document.addEventListener('DOMContentLoaded', function() {
  initializeProductCards();
  initializeCartDrawer();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        initializeProductCards();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('related-products')) {
      initializeProductCards();
    }
  });
});

function initializeProductCards() {
  const productCards = document.querySelectorAll('.product-card-wrapper, .related-products .grid__item');
  productCards.forEach(initializeProductCard);
}

function initializeProductCard(productCard) {
  const productUrl = productCard.querySelector('.card__heading a').href;
  updateVariantSelector(productCard, productUrl);

  const addToCartForm = productCard.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', handleAddToCart);
  }
}

function initializeCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  if (!cartDrawer.open) {
    cartDrawer.open = function() {
      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    };
  }

  if (!cartDrawer.close) {
    cartDrawer.close = function() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    };
  }

  const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
  if (overlay) {
    overlay.addEventListener('click', () => cartDrawer.close());
  }
}

function updateVariantSelector(parent, productUrl) {
  const variantSelector = parent.querySelector('.product-variant-selector');
  const variantDropdown = parent.querySelector('.variant-dropdown');
  const productForm = parent.querySelector('.product-form');
  const selectedVariantInput = parent.querySelector('.selected-variant-id');
  const submitButton = parent.querySelector('.product-variant-submit-button');
  const soldOutMessage = parent.querySelector('.sold-out-message');
  
  if (!variantSelector || !variantDropdown || !productForm || !selectedVariantInput) {
    return;
  }

  if (variantDropdown.options.length <= 1) {
    fetch(productUrl + '.js')
      .then(response => response.json())
      .then(product => {
        const availableVariants = product.variants.filter(v => v.available);
        
        if (availableVariants.length === 0) {
          variantSelector.style.display = 'none';
          if (soldOutMessage) soldOutMessage.style.display = 'flex';
        } else {
          variantSelector.style.display = 'block';
          if (soldOutMessage) soldOutMessage.style.display = 'none';
          
          renderVariantOptions(variantDropdown, product.variants);
          
          if (availableVariants.length > 0) {
            selectVariant(parent, availableVariants[0].id);
          }
        }
      })
      .catch(error => console.error('Error loading variants:', error));
  }
}

function renderVariantOptions(dropdown, variants) {
  while (dropdown.options.length > 1) {
    dropdown.remove(1);
  }

  variants.forEach(variant => {
    const option = document.createElement('option');
    option.value = variant.id;
    option.textContent = variant.title;
    option.disabled = !variant.available;
    dropdown.add(option);
  });

  dropdown.addEventListener('change', function() {
    selectVariant(this.closest('.product-card-wrapper'), this.value);
  });
}

function selectVariant(parent, variantId) {
  const variantDropdown = parent.querySelector('.variant-dropdown');
  const selectedVariantInput = parent.querySelector('.selected-variant-id');
  const submitButton = parent.querySelector('.product-variant-submit-button');
  
  if (variantDropdown) variantDropdown.value = variantId;
  if (selectedVariantInput) selectedVariantInput.value = variantId;
  if (submitButton) submitButton.disabled = variantId === "";
}

function handleAddToCart(event) {
  event.preventDefault();
  const form = event.target;
  const submitButton = form.querySelector('[type="submit"]');
  const originalButtonText = submitButton.innerHTML;

  submitButton.setAttribute('disabled', true);
  submitButton.innerHTML = '<span>Añadiendo...</span>';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(Object.fromEntries(new FormData(form))),
  })
  .then(response => response.json())
  .then(item => {
    updateCartDrawer(true);
    updateCartIconBubble();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  })
  .finally(() => {
    submitButton.removeAttribute('disabled');
    submitButton.innerHTML = originalButtonText;
  });
}

function updateCartDrawer(openDrawer = false) {
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const newDrawerContent = newDocument.querySelector('.drawer__inner');
      const cartDrawer = document.querySelector('cart-drawer');

      if (newDrawerContent && cartDrawer) {
        const currentDrawerContent = cartDrawer.querySelector('.drawer__inner');
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
        cartDrawer.classList.toggle('is-empty', newDrawerContent.classList.contains('is-empty'));

        if (openDrawer) {
          cartDrawer.open();
        }
      }

      updateCartIconBubble();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
}

function updateCartIconBubble() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (cartIconBubble) {
        const itemCount = cart.item_count;
        const counterElement = cartIconBubble.querySelector('.cart-count-bubble span');
        
        if (counterElement) {
          counterElement.textContent = itemCount;
          counterElement.closest('.cart-count-bubble').classList.toggle('hide', itemCount === 0);
        } else if (itemCount > 0) {
          const newCounterElement = document.createElement('div');
          newCounterElement.className = 'cart-count-bubble';
          newCounterElement.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} artículo(s)</span>`;
          cartIconBubble.appendChild(newCounterElement);
        }
      }
    })
    .catch(error => {
      console.error('Error updating cart icon:', error);
    });
}